export default "__VITE_ASSET__BVyLLBol__"